import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, tap } from "rxjs";

import { AUTH_SERVICE_TOKEN, AuthFacade } from "@coin-depo-core/auth";
import { StorageService } from "@coin-depo-core/storage";
import { ApiService } from "@coin-depo/http";

import { HistoricalTokenBalanceFacade } from "@coin-depo-core/governance";

@Injectable({
    providedIn: 'root',
  })
export class GovernanceHistoricalTokenBalanceService implements HistoricalTokenBalanceFacade {
    protected storageKeyHistoricalTokenBalanceDates = 'historicalTokenBalanceDates';

    protected historicalTokenBalanceDates$ = new BehaviorSubject<any>(
        this.storage.get(this.storageKeyHistoricalTokenBalanceDates, null)
    );

    cachedHistoricalTokenBalanceDates$ =
        this.historicalTokenBalanceDates$.asObservable();

    constructor(
        @Inject(AUTH_SERVICE_TOKEN) private auth: AuthFacade,
        private storage: StorageService,
        private api: ApiService,
    ) {}

    getHistoricalTokenBalance(
        params: any
    ) {
        const userData = this.auth.userData;

        const data: any = {
            client_token: this.auth.accessToken,
            username: userData.email,
            ...params,
        };

        return this.api
            .getHistoricalTokenBalance(data)
            .pipe(
                tap(res => {
                    if (res.status === 'success') {
                        this.setHistoricalTokenBalance(res);
                    }
                })
            );
    }

    private setHistoricalTokenBalance(res: any) {
        this.historicalTokenBalanceDates$.next(res.res);

        this.storage.set(
            this.storageKeyHistoricalTokenBalanceDates,
            res.res
        );
    }

    getHistoricalTokenBalanceDatesSnapshot(): any {
        return this.historicalTokenBalanceDates$.value;
    }
}